import { Outlet } from "react-router-dom";
import LoginForm from "../components/loginPage/LoginForm";
import { useContext, useEffect } from "react";
import '../style/components/loginEmp.css'
import { auth } from "../context/auth";
import { decryptData, loadFromCookie } from "../funcs/EncEmp";
import LogoWork from "../components/global/logoWork";
import { useTranslation } from "react-i18next";

export default function LoginEmp() {
    const { t } = useTranslation();

    const SECRET = process.env.REACT_APP_SECRET_KEY;
    const { ActivEmp, setActiveEmp, user }  = useContext(auth);
    useEffect(() => {
        const verifyEmp = async () => {
            try {   
                const verfiyPayload = loadFromCookie("session_emp");
                const decrypted = await decryptData(verfiyPayload, SECRET);
                if(!decrypted) {
                    return;
                }
                setActiveEmp({   
                    code: decrypted.data.code,
                    name: decrypted.data.name,
                    role: decrypted.data.role
                });
            } catch (error) {

            }
        }
        verifyEmp();
    }, [])
    return  ActivEmp ? 
    <Outlet />
    :
    (
        <div className="container-login-emp flex flex-center-center">
            <div className="box">
                <LogoWork logo={user.data[0].logo} />
                <h2 className="text-weight-light">{t("common:WelcomeEmployee")}</h2>
                <LoginForm mode="loginEmp" enableForgetPass={true} />
            </div>
        </div>
    )
}